import { makeAutoObservable, runInAction } from 'mobx';

class CardModel {
    id = null;
    image = '';
    variationRate = 0;
    currentRate = 0;
    baseRate = 0;
    cardPrice = 0;
    publicAt = '';
    airdrop = 0;
    isHolded = false;
    exchange = {};
    token = {};

    constructor(data, rootStore) {
        Object.assign(this, data);
        this.rootStore = rootStore;
        makeAutoObservable(this, {}, { autoBind: true });
    }


    updateRates({ currentRate, variationRate }) {
        // console.log(currentRate)
        runInAction(() => {
            this.currentRate = currentRate;
            this.variationRate = variationRate;
        });
    }
}

export default CardModel;